import UniqueId from './unique-id';
import DateUtils from "./dateUtils";
import StringUtils from "./stringUtils";
import NumberUtils from "./numberUtils";
import StatusMapper from './statusMapper'
import resourceMapper from './resourceMapper'
import ViewUtils from './viewUtils'

const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value(event, el);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: el => {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

function configureApp(appInstance){
  appInstance.use(UniqueId);
  appInstance.use(DateUtils, "es", null);
  appInstance.use(StringUtils);
  appInstance.use(NumberUtils, "de-DE");
  appInstance.use(StatusMapper);
  appInstance.use(resourceMapper);
  appInstance.use(ViewUtils);
  appInstance.directive("click-outside", clickOutside);
}

export default {
  configureApp
}